import * as audio from './audio.js';
import * as scene from './scene.js';
import * as main from './main.js';
import * as map from './map.js';
import * as player from './player.js';

export {
    init,
    status,
    showMenu,
    showMessage,
    showMap,
}

let activeModal = null;

function init() {
    document.querySelector('.js-start').addEventListener('click', () => {
        if (DEVMODE) console.log('Starting...');
        document.querySelector('#menu').classList.add('hidden');
        document.querySelector('main').classList.remove('hidden');
        audio.resume().then(() => {
            scene.start();
        });
        main.loop();
    });

    document.querySelector('.js-close').addEventListener('click', (event) => {
        document.querySelector('.modal-wrapper').classList.add('hidden');
        activeModal = null;
        player.config.controllable = true;
    });

    document.querySelector('.modal-wrapper').addEventListener('click', (event) => {
        if (event.target !== event.currentTarget) return;
        document.querySelector('.modal-wrapper').classList.add('hidden');
        activeModal = null;
    });
}

function status(status) {
    const statusEl = document.querySelector('#status');
    if (status === null) statusEl.style.display = 'none';
    statusEl.innerText = status;
}

function showMenu() {
    document.querySelector('#menu').classList.remove('hidden');

    status(null);
}

function showMessage(text, title = null) {
    if (activeModal !== 'message') {
        activeModal = 'message';
        document.querySelector('.modal-content').innerHTML = `
            <h2 class="title">${title}</h2>
            <p class="message">${text}</p>
        `.trim();
        document.querySelector('.modal-wrapper').classList.remove('hidden');
        player.config.controllable = false;
    } else {
        activeModal = null;
        document.querySelector('.modal-wrapper').classList.add('hidden');
        player.config.controllable = true;
    }
}

function showMap() {
    if (activeModal !== 'map') {
        activeModal = 'map';
        const modal = document.querySelector('.modal-content');
        modal.innerHTML = `
            <p>Carte</p>
        `.trim();
        modal.appendChild(map.getCanvas());
        map.draw();
        document.querySelector('.modal-wrapper').classList.remove('hidden');
        player.config.controllable = false;
    } else {
        activeModal = null;
        document.querySelector('.modal-wrapper').classList.add('hidden');
        player.config.controllable = true;
    }
}